module.exports = __webpack_public_path__ + "263b20716d541bb151cc38100bca0549.svg";